import React, { useState } from 'react'
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import MyModal from '../../../../../../UI/modal/MyModal';
import ChangeReceivedForm from './ChangeReceivedForm';
import SupplyBillAgreeIco from '../../../../../supplyBill/view/items/SupplyBillAgreeIco';
import IcoButtonStatus from '../../../../../../UI/form/icoButtons/IcoButtonStatus';
import ReceivedItemIco from './ReceivedItemIco';

const ChangeReceivedButton = ({ supplyOrderItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        {/* <SupplyBillAgreeIco
            onClick={e => setOpen(true)}
            text={'Чи отримано замовником?'}
            ico={<SentimentSatisfiedAltIcon />}
            // value={supplyOrderItem.isReceived}
            value={
                supplyOrderItem.isReceived
            }
        /> */}
        <ReceivedItemIco 
            supplyOrderItem={supplyOrderItem}
            setOpen={setOpen}
        />
        {/* <IcoButtonStatus
            // classNameMain={}
            ico={
                <span>
                    <SentimentSatisfiedAltIcon />
                    {
                        supplyOrderItem.countReceived ? 
                            <span>
                                {supplyOrderItem.countReceived}
                            </span>
                        : ''
                    }
                </span>
            }
            text={'Отримання замовником'}
            textStatus={
                supplyOrderItem.isReceived ? 'Отримано' : 'Не отримано'
            }
            status={
                supplyOrderItem.isReceived ? 'pay' : ''
            }
            onClick={e => setOpen(true)}
        /> */}

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагування отримання'}
            disableClickOutside={true}
            content={
                <ChangeReceivedForm
                    supplyOrderItemBd={supplyOrderItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeReceivedButton